/* @flow */
import dateTimeFormat from 'lib/dateTimeFormat';

const MILLIS_PER_MINUTE = 60 * 1000;

export const formatDate = (dt: Date, range: string): string => {
  // Shift date so that i18n formats based on UTC time.
  const tzOffset = dt.getTimezoneOffset() * MILLIS_PER_MINUTE;
  const initial = new Date(dt.getTime() + tzOffset);

  // For weeks we show ranges from d/m - d/m
  if (range === 'week') {
    const today = new Date();
    const nextPeriod = new Date(initial.getTime() + 604800000);
    const final = nextPeriod < today ? nextPeriod : today;
    const fmtOptions = { day: 'numeric', month: 'numeric' };
    const initialFormatted = dateTimeFormat(initial, fmtOptions);
    const finalFormatted = dateTimeFormat(final, fmtOptions);
    return `${initialFormatted} - ${finalFormatted}`;
  }

  // For months we show mm 'yy
  if (range === 'month') {
    const fmtOptions = { month: 'short', year: '2-digit' };
    return dateTimeFormat(initial, fmtOptions).replace(' ', ' ’');
  }

  // For days (and all extraneous situations) we show m/d/y
  return dateTimeFormat(initial);
};

export const formatData = (data: Array<Object>, dateRange: string) => {
  const newData: Array<*> = data.map(entry => {
    return Object.keys(entry).reduce((newEntry, key) => {
      const newKey = key[0].toUpperCase() + key.substring(1);
      if (key === 'date') {
        const date = new Date(entry[key]);
        newEntry[newKey] = formatDate(date, dateRange);
      } else {
        newEntry[newKey] = entry[key];
      }
      return newEntry;
    }, {});
  });

  return newData;
};
